import {getCookie, setCookie} from '../common/Utils';
import Modal from '../modal/Modal';
import {checkCookie} from './checkCookie';


/**
 * 이미지 배너
 * 메인페이지에서만 노출
 * 그만보기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 */



class ImageLayer {
    constructor(_isMain= false, _isLauncher = false, _data = {}, _i18n={}) {

        this.isCookieApply = checkCookie();
        let thisIsCookieApply = this.isCookieApply && getCookie(_data.imageCookie);

        if( !_isMain || !_data.showImageBanner || thisIsCookieApply ){
            return false;
        }

        if ( _isLauncher && !_data.movieLauncherShow) {
            return false;
        }

        let customClassName = ( _data.imageOrientationVertical)? 'imgBannerVertical' : '' ;

        let ncBannerModalImage = new Modal({
            id: 'NC-banner-modal',
            className: customClassName,
            contents: `
                ${_data.imageLink != ''?`
                    ${_data.imageLinkNewWindow ? `
                    <div class="nc-banner-modal-mobile"><a href="${_data.imageLink}" target="_blank"><img src="${_data.imageMobileBG}"></a></div><div class="nc-banner-modal-pc"><a href="${_data.imageLink}" target="_blank"><img src="${_data.imagePcBG}"></a></div>
                    ` :`
                    <div class="nc-banner-modal-mobile"><a href="${_data.imageLink}"><img src="${_data.imageMobileBG}"></a></div><div class="nc-banner-modal-pc"><a href="${_data.imageLink}"><img src="${_data.imagePcBG}"></a></div>
                    `}
                `
                 : `
                 <div class="nc-banner-modal-mobile"><img src="${_data.imageMobileBG}"></div><div class="nc-banner-modal-pc"><img src="${_data.imagePcBG}"></div>
                 `}`,
            primaryBtnText: _i18n.banner.btn.stop_watching,
            cancelBtnText: _i18n.banner.btn.close,
            willOpen: ()=>{},
            didClose: (_result)=>this.addEvents( _result, _data )
        });

        ncBannerModalImage.open();


    }
    addEvents(_result, _data){
        if(_result) {
            if(this.isCookieApply){
                setCookie('ncBanner'+_data.imageCookie, "true", 100, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
                setCookie('ncBanner'+_data.imageCookie, "true", 100, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
                setCookie('ncBanner'+_data.imageCookie, "true", 100, '.plaync.com'); // 쿠키 사용
            }
        }
    }

}
export default ImageLayer;